(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-dynamic-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('gn-dynamic-sticky-header')) { customElements.define('gn-dynamic-sticky-header', StickyHeader); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["empty-cart-promotions"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* -------------------- small helpers -------------------- */
  function $(root, sel){ return (root || document).querySelector(sel); }
  function $all(root, sel){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ----------- defer background images via IntersectionObserver ----------- */
  function hydratePromoBgs(scope){
    var nodes = $all(scope, '.promo-bg[data-bg]');
    if(!nodes.length) return;

    function setBg(el){
      if(el.dataset.bgHydrated==='1') return;
      var useLg = window.innerWidth >= 768 && el.getAttribute('data-bg-lg');
      var url = useLg ? el.getAttribute('data-bg-lg') : el.getAttribute('data-bg');
      if(url){ el.style.backgroundImage = "url('"+url+"')"; el.dataset.bgHydrated='1'; }
    }

    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ setBg(e.target); io.unobserve(e.target); } });
      }, { root:null, rootMargin:'200px', threshold:0 });
      nodes.forEach(function(n){ io.observe(n); });
    } else {
      nodes.forEach(setBg);
    }
  }

  /* -------------------- arrows / progress -------------------- */
  function addArrows(slider){
    var prev = slider.querySelector('.ecp-fb-prev');
    var next = slider.querySelector('.ecp-fb-next');
    if (prev && next) return { prev, next };
    slider.style.position = 'relative';
    prev = document.createElement('button');
    prev.className = 'ecp-fb-nav ecp-fb-prev';
    prev.setAttribute('aria-label','Previous');
    prev.innerHTML = '<svg viewBox="0 0 20 20" fill="none"><path d="M12 4L6 10l6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    next = document.createElement('button');
    next.className = 'ecp-fb-nav ecp-fb-next';
    next.setAttribute('aria-label','Next');
    next.innerHTML = '<svg viewBox="0 0 20 20" fill="none"><path d="M8 4l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    slider.appendChild(prev); slider.appendChild(next);
    return { prev, next };
  }

  function ensureProgress(slider){
    var root = slider.closest('.empty-cart-promotions');
    if (!root || root.getAttribute('data-bar') !== 'true') return null;
    var wrap = slider.querySelector('.swiper-wrapper');
    if (!wrap) return null;
    var bar = slider.querySelector('.ecp-progress');
    if (!bar){
      bar = document.createElement('div');
      bar.className = 'ecp-progress';
      var input = document.createElement('input');
      input.type = 'range'; input.min = 0; input.max = 100; input.value = 0; input.setAttribute('aria-label','Scroll position');
      bar.appendChild(input);
      slider.appendChild(bar);
    }
    return bar;
  }

  function bindProgressToScroll(slider){
    if (slider.dataset.fbBarBound === '1') return;
    var wrap = slider.querySelector('.swiper-wrapper'); if (!wrap) return;
    var bar = ensureProgress(slider); if (!bar) return;
    var input = bar.querySelector('input');
    var updating = false, max = 0;

    function recalc(){ max = Math.max(0, wrap.scrollWidth - wrap.clientWidth); if(max<1){ input.value = 0; } }
    function syncFromScroll(){ if (updating) return; var pct = (max>0)? Math.min(100, Math.max(0, (wrap.scrollLeft / max) * 100)) : 0; input.value = pct; }
    function syncFromInput(){ updating = true; var next = (parseFloat(input.value||'0')/100) * max; wrap.scrollTo({ left: next, behavior: 'smooth' }); setTimeout(function(){ updating=false; }, 120); }

    recalc();
    wrap.addEventListener('scroll', function(){ window.requestAnimationFrame(syncFromScroll); }, { passive:true });
    window.addEventListener('resize', function(){ recalc(); syncFromScroll(); }, { passive:true });
    input.addEventListener('input', syncFromInput);
    input.addEventListener('keydown', function(e){
      var k = e.key; if (k === 'ArrowLeft' || k === 'ArrowRight'){
        var delta = (k === 'ArrowLeft' ? -1 : 1) * (100 / 12);
        input.value = Math.min(100, Math.max(0, parseFloat(input.value||'0') + delta));
        syncFromInput();
      }
    });

    slider.dataset.fbBarBound = '1';
  }

  function bindProgressToSwiper(slider, swiper){
    if (!swiper) return;
    var bar = ensureProgress(slider); if (!bar) return; var input = bar.querySelector('input'); var syncing = false;

    function pages(){ var n = (swiper.snapGrid && swiper.snapGrid.length) ? swiper.snapGrid.length - 1 : 0; return Math.max(1, n); }
    function updateFromSwiper(){ if (syncing) return; var p = pages(); var idx = (typeof swiper.snapIndex==='number')? swiper.snapIndex : 0; var pct = (p>0)? (idx/p)*100 : 0; input.value = Math.min(100, Math.max(0, pct)); }
    function slideToProgress(pct){ var p = pages(); var t = Math.min(1, Math.max(0, pct/100)); var idx = Math.round(t * p); if (swiper.params.loop && typeof swiper.slideToLoop==='function'){ swiper.slideToLoop(idx); } else { swiper.slideTo(idx); } }

    swiper.on('slideChange', updateFromSwiper);
    swiper.on('progress', function(){ requestAnimationFrame(updateFromSwiper); });
    swiper.on('resize', updateFromSwiper);
    input.addEventListener('input', function(){ syncing = true; slideToProgress(parseFloat(input.value||'0')); setTimeout(function(){ syncing=false; }, 100); });
    updateFromSwiper();
  }

  function gapPx(el){ var cs = getComputedStyle(el); var g = parseFloat(cs.columnGap || cs.gap || '16'); return isNaN(g) ? 16 : g; }

  /* -------------------- fallback (no Swiper) row/grid -------------------- */
  function bindFallbackRow(slider){
    if (slider.dataset.fbBound === '1') return;
    var wrap = slider.querySelector('.swiper-wrapper'); if (!wrap) return;
    var arrows = addArrows(slider);
    function step(){ var first = slider.querySelector('.swiper-slide'); if (!first) return 320; return first.getBoundingClientRect().width + gapPx(wrap); }
    arrows.prev.addEventListener('click', function(){ wrap.scrollBy({ left: -step(), behavior:'smooth' }); });
    arrows.next.addEventListener('click', function(){ wrap.scrollBy({ left:  step(), behavior:'smooth' }); });
    bindProgressToScroll(slider);
    var down=false, startX=0, startLeft=0, pid=null;
    wrap.addEventListener('pointerdown', function(e){ down=true; pid=e.pointerId; wrap.setPointerCapture(pid); startX=e.clientX; startLeft=wrap.scrollLeft; }, { passive:true });
    wrap.addEventListener('pointermove', function(e){ if(!down) return; wrap.scrollLeft = startLeft - (e.clientX - startX); }, { passive:true });
    function end(){ if(pid!==null){ try{wrap.releasePointerCapture(pid);}catch(_){ } } down=false; pid=null; }
    wrap.addEventListener('pointerup', end, { passive:true });
    wrap.addEventListener('pointerleave', end, { passive:true });
    slider.dataset.fbBound = '1';
  }

  function bindFallbackGrid(slider){
    if (slider.dataset.fbGridBound === '1') return;
    var wrap = slider.querySelector('.swiper-wrapper'); if (!wrap) return;
    var arrows = addArrows(slider);
    function columnWidth(){ var first = slider.querySelector('.swiper-slide'); if (!first) return 360; return first.getBoundingClientRect().width + gapPx(wrap); }
    arrows.prev.addEventListener('click', function(){ wrap.scrollBy({ left: -columnWidth(), behavior:'smooth' }); });
    arrows.next.addEventListener('click', function(){ wrap.scrollBy({ left:  columnWidth(), behavior:'smooth' }); });
    bindProgressToScroll(slider);
    var down=false, startX=0, startLeft=0, pid=null;
    wrap.addEventListener('pointerdown', function(e){ down=true; pid=e.pointerId; wrap.setPointerCapture(pid); startX=e.clientX; startLeft=wrap.scrollLeft; }, { passive:true });
    wrap.addEventListener('pointermove', function(e){ if(!down) return; wrap.scrollLeft = startLeft - (e.clientX - startX); }, { passive:true });
    function end(){ if(pid!==null){ try{wrap.releasePointerCapture(pid);}catch(_){ } } down=false; pid=null; }
    wrap.addEventListener('pointerup', end, { passive:true });
    wrap.addEventListener('pointerleave', end, { passive:true });
    slider.dataset.fbGridBound = '1';
  }

  /* -------------------- Swiper initializers -------------------- */
  function initGridSliders(root){
    if (!window.Swiper) return false;
    $all(root, '.promo-slider[data-has-grid="true"]').forEach(function(el){
      if (el.dataset.swiperInited === '1') return;
      var total = el.querySelectorAll('.swiper-slide').length;
      try{
        var arrows = addArrows(el);
        var loopDesktop = (window.innerWidth >= 768) && (total > 4);
        var instance = new Swiper(el, {
          slidesPerView: 1.25,
          spaceBetween: 12,
          loop: loopDesktop,
          grid: { rows: 2, fill: 'column' },
          navigation: { prevEl: arrows.prev, nextEl: arrows.next },
          breakpoints: {
            768:  { slidesPerView: 1.25, spaceBetween: 14 },
            1200: { slidesPerView: 1.25, spaceBetween: 16 }
          },
          grabCursor: true
        });
        bindProgressToSwiper(el, instance);
        el.dataset.swiperInited = '1';
      }catch(err){ /* keep fallback */ }
    });
    return true;
  }

  function initRowAsSwiper(slider){
    if (!window.Swiper || slider.dataset.swiperInited === '1') return false;
    var total = slider.querySelectorAll('.swiper-slide').length;
    var desktopSPV = (total >= 3) ? 2.1 : 1.25;
    var arrows = addArrows(slider);
    try{
      var loopDesktop = (window.innerWidth >= 768) && (total >= 3);
      var instance = new Swiper(slider, {
        slidesPerView: 1.1,
        spaceBetween: 12,
        slidesPerGroup: 1,
        loop: loopDesktop,
        watchOverflow: false,
        grabCursor: true,
        navigation: { prevEl: arrows.prev, nextEl: arrows.next },
        breakpoints: {
          640:  { slidesPerView: 1.3, spaceBetween: 14 },
          768:  { slidesPerView: desktopSPV, spaceBetween: 16 },
          1200: { slidesPerView: desktopSPV, spaceBetween: 18 }
        }
      });
      bindProgressToSwiper(slider, instance);
      slider.dataset.swiperInited = '1';
      return true;
    }catch(err){ return false; }
  }

  function initRowSliders(root){
    var rows = $all(root, '.promo-slider--row');
    rows.forEach(function(slider){ bindFallbackRow(slider); initRowAsSwiper(slider); });
  }

  function initGridFallbacks(root){ $all(root, '.promo-slider--grid').forEach(function(slider){ if (!slider.classList.contains('swiper-initialized')) bindFallbackGrid(slider); }); }

  /* -------------------- bootstrap -------------------- */
  function initAll(root){
    hydratePromoBgs(root);
    initRowSliders(root);
    initGridFallbacks(root);
    if (window.Swiper){ initGridSliders(root); $all(root, '.promo-slider--row').forEach(initRowAsSwiper); }
  }

  function onReady(){
    var sectionRoot = document.currentScript && document.currentScript.closest ? document.currentScript.closest('.empty-cart-promotions') : document;
    initAll(document);

    // Scoped MutationObserver with debounce
    var ecp = document.querySelector('.empty-cart-promotions');
    if('MutationObserver' in window && ecp){
      var t; var mo = new MutationObserver(function(){ clearTimeout(t); t = setTimeout(function(){ initAll(ecp); }, 120); });
      mo.observe(ecp, { childList:true, subtree:true });
    }

    // Upgrade when Swiper script signals readiness
    window.addEventListener('swiper:ready', function(){ initGridSliders(document); $all(document, '.promo-slider--row').forEach(initRowAsSwiper); }, { passive:true });

    // Re-init if cart drawer opens (scope to drawer for smaller DOM)
    document.addEventListener('cart:drawer:open', function(){ var drawer = document.getElementById('CartDrawer') || document; initAll(drawer); }, { passive:true });

    // Limited retry if Swiper loads slightly later (2s total)
    if(!window.Swiper){
      var tries=0, maxTries=8, iv = setInterval(function(){
        if(window.Swiper){ initGridSliders(document); $all(document, '.promo-slider--row').forEach(initRowAsSwiper); clearInterval(iv); }
        if(++tries>=maxTries) clearInterval(iv);
      }, 250);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', onReady, { once:true });
  } else { onReady(); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
